var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "new-ticket-form",
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.createTicket()
        }
      }
    },
    [
      _c("section", { staticClass: "request-form-section" }, [
        _c(
          "div",
          { staticClass: "request-field-grid" },
          [
            _c("portal-select-field", {
              attrs: {
                "field-class": "request-type-field",
                label: _vm.$t("requests.new.type"),
                options: _vm.ticketTypeOptions
              },
              model: {
                value: _vm.ticketType,
                callback: function($$v) {
                  _vm.ticketType = $$v
                },
                expression: "ticketType"
              }
            }),
            _c("label", { staticClass: "request-text-field" }, [
              _c("span", [_vm._v(_vm._s(_vm.$t("requests.new.subject")))]),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.subject,
                    expression: "subject"
                  }
                ],
                attrs: {
                  type: "text",
                  "aria-label": _vm.$t("requests.new.subject")
                },
                domProps: { value: _vm.subject },
                on: {
                  input: function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.subject = $event.target.value
                  }
                }
              })
            ]),
            _c("contact-selector", {
              staticClass: "request-contact-field",
              attrs: {
                "to-list": _vm.ccList,
                contacts: _vm.contacts,
                label: _vm.$t("requests.new.cc")
              },
              on: { update: _vm.updateCcList }
            })
          ],
          1
        )
      ]),
      _c(
        "section",
        { staticClass: "request-form-section request-details-section" },
        [
          _vm.selectedType.discoveryTemplate
            ? _c(
                "div",
                {
                  staticClass: "request-dynamic-form",
                  style: _vm.requestFormStyle
                },
                [
                  _vm.selectedType.discoveryTemplate.schemaVersion == 1
                    ? _c("ticket-form-v1", {
                        key: _vm.selectedType.discoveryTemplate.id,
                        ref: "form",
                        attrs: { template: _vm.selectedType.discoveryTemplate }
                      })
                    : _vm._e(),
                  _vm.selectedType.discoveryTemplate.schemaVersion == 2
                    ? _c("ticket-form-v2", {
                        key: _vm.selectedType.discoveryTemplate.id,
                        ref: "form",
                        attrs: { template: _vm.selectedType.discoveryTemplate }
                      })
                    : _vm._e()
                ],
                1
              )
            : _c("label", { staticClass: "request-textarea-field" }, [
                _c("span", [_vm._v(_vm._s(_vm.$t("requests.new.details")))]),
                _c("textarea", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.comment,
                      expression: "comment"
                    }
                  ],
                  attrs: {
                    rows: "8",
                    "aria-label": _vm.$t("requests.new.details")
                  },
                  domProps: { value: _vm.comment },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.comment = $event.target.value
                    }
                  }
                })
              ])
        ]
      ),
      _c("portal-file-input", {
        attrs: {
          label: _vm.$t("requests.new.attachments"),
          placeholder: _vm.$t("requests.new.upload-attachments"),
          "remove-label": _vm.$t("global.delete")
        },
        model: {
          value: _vm.attachments,
          callback: function($$v) {
            _vm.attachments = $$v
          },
          expression: "attachments"
        }
      }),
      _c("footer", { staticClass: "request-form-actions" }, [
        _c(
          "button",
          {
            staticClass: "cancel-request-action",
            attrs: { type: "button" },
            on: {
              click: function($event) {
                return _vm.confirmCancel()
              }
            }
          },
          [_vm._v(" " + _vm._s(_vm.$t("global.cancel")) + " ")]
        ),
        _c(
          "button",
          { staticClass: "submit-request-action", attrs: { type: "submit" } },
          [_vm._v(" " + _vm._s(_vm.$t("requests.new.submit")) + " ")]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }